// src/config.js
//
// Resolves in this order: window.__ESD_CONFIG__ (written by
// docker-entrypoint.sh from the container's env vars at startup, so one
// built image can be promoted unchanged across environments) -> CRA
// build-time process.env.REACT_APP_* (used by `npm start`, which never
// loads config.js from a container) -> hardcoded fallback.
const runtime = (typeof window !== 'undefined' && window.__ESD_CONFIG__) || {};

const pick = (runtimeVal, envVal, fallback) => {
    if (typeof runtimeVal === 'string' && runtimeVal.trim() !== '') return runtimeVal;
    if (envVal) return envVal;
    return fallback;
};

export const config = {
    apiUrl: pick(runtime.apiUrl, process.env.REACT_APP_API_URL, ''),
    gaId: pick(runtime.gaId, process.env.REACT_APP_GA_ID, undefined),
    supportEmail: pick(runtime.supportEmail, process.env.REACT_APP_SUPPORT_EMAIL, 'mehrab.mahdian@taltech.ee'),
    githubUrl: pick(runtime.githubUrl, process.env.REACT_APP_GITHUB_URL, 'https://github.com/taltechloc/electrospinning-data.org'),
    siteUrl: pick(runtime.siteUrl, process.env.REACT_APP_SITE_URL, 'https://electrospinning-data.org'),
    docsUrl: pick(runtime.docsUrl, process.env.REACT_APP_DOCS_URL, 'https://docs.electrospinning-data.org'),
    // Public Turnstile site key - safe to ship to the browser (unlike the secret key, which
    // only ever lives on the backend). Registration fails closed server-side if this is unset,
    // so an empty value here just means the widget doesn't render rather than a security gap.
    turnstileSiteKey: pick(runtime.turnstileSiteKey, process.env.REACT_APP_TURNSTILE_SITE_KEY, undefined),
};

export default config;
